import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { Moment } from "moment";
import React, { useCallback, useState } from "react";

import { useAddOwnerFlow } from "./AddOwnerFlowContext";
import { useAddOwner } from "./useAddOwner";

export function UpdateLeaseDialog() {
    const {
        box,
        selectedOwnerId,
        setSelectedOwnerId,
        openUpdateLeaseDialog,
        setOpenUpdateLeaseDialog,
        onOwnerAdded,
    } = useAddOwnerFlow();

    const [leaseEndDate, setLeaseEndDate] = useState<Moment | null>(null);
    const { addOwner, loading } = useAddOwner(box.id);

    const handleSubmit = useCallback(() => {
        if (!selectedOwnerId) return;
        addOwner(
            selectedOwnerId,
            leaseEndDate && leaseEndDate.toISOString(),
            true,
            () => {
                setOpenUpdateLeaseDialog(false);
                onOwnerAdded();
            },
        );
    }, [
        addOwner,
        selectedOwnerId,
        leaseEndDate,
        onOwnerAdded,
        setOpenUpdateLeaseDialog,
    ]);

    const handleClose = useCallback(() => {
        setOpenUpdateLeaseDialog(false);
        setSelectedOwnerId(null);
    }, [
        setSelectedOwnerId,
        setOpenUpdateLeaseDialog,
    ]);

    return (
        <Dialog open={openUpdateLeaseDialog} onClose={handleClose}>
            <DialogTitle>
                Update existing Lease
            </DialogTitle>

            <DialogContent>
                <DatePicker
                    label="End Date"
                    value={leaseEndDate}
                    variant="dialog"
                    onChange={date => setLeaseEndDate(date)}
                    format="YYYY/MM/DD"
                />

                <Button disabled={loading} onClick={handleSubmit}>
                    Submit
                </Button>
            </DialogContent>
        </Dialog>
    );
}
